import { render, staticRenderFns } from "./addbyinbound.vue?vue&type=template&id=33770f94"
import script from "./addbyinbound.vue?vue&type=script&lang=js"
export * from "./addbyinbound.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports